// Warning: this will be re-generated on CI server
export const APP_VERSION: string = "1.0.0";
export const APP_BUILD_NUMBER: string = "1164";
export const APP_BUILD_TIME: number = 1745485218280;
export const APP_GIT_COMMIT: string = "fe33cfdd";
export const APP_GIT_BRANCH: string = "main";
